export default __webpack_public_path__ + "static/media/PrayerMorning.879973f3.svg";